import { httpClient } from '@/services/http/httpClient'

export type CommunicationField =
  | 'hasEmailNotifications'
  | 'hasInAppNotifications'

type UpdateCommunicationSettingsParams = {
  tennantId: string
  hasEmailNotifications?: boolean
  hasInAppNotifications?: boolean
}

export async function updateCommunicationSettings({
  tennantId,
  hasEmailNotifications,
  hasInAppNotifications,
}: UpdateCommunicationSettingsParams): Promise<void> {
  await httpClient.patch('/tennants/communication-settings', {
    tennantId,
    ...(hasEmailNotifications !== undefined && { hasEmailNotifications }),
    ...(hasInAppNotifications !== undefined && { hasInAppNotifications }),
  })
}
